import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const IconDash = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
     <path d="M1.33334 14V12.6667H14.6667V14H1.33334ZM2.00001 12V7.33333H4.00001V12H2.00001ZM5.33334 12V4H7.33334V12H5.33334ZM8.66668 12V6H10.6667V12H8.66668ZM12 12V2H14V12H12Z" />

    </SvgIcon>
  );
};

export default IconDash;


// <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
// <mask id="mask0_4058_8319" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
// <rect width="16" height="16" fill="#D9D9D9"/>
// </mask>
// <g mask="url(#mask0_4058_8319)">
// </g>
// </svg>
